import { useMessageStates } from '@/common/app/message'

import FormMessageList from '@/components/container/form/widgets/FormMessageList'

const LoginPageMessages = () => {
  const [messages, setMessages] = useMessageStates()

  return <FormMessageList messageStates={messages} setMessageStates={setMessages} />
}

export default LoginPageMessages
